
import { useLanguage } from '../../contexts/LanguageContext';
import { useData } from '../../contexts/DataContext';
import { useTranslation } from 'react-i18next';

const VisionDesktop = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const result = useData();
  const vision = result.data.vision;
  const mission = result.data.mission;

  return (
    <div className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Vision Section */}
          <div className="flex flex-col gap-6" data-aos="fade-right">
            <h3 className="text-4xl font-bold">{vision.title}</h3>
            <p className="text-lg text-gray-300 leading-relaxed">{vision.description}</p>
          </div>
          <div className="relative" data-aos="fade-left">
            {vision.image && (
              <div className="overflow-hidden rounded-xl shadow-lg">
                <img
                  src={vision.image}
                  alt="Vision"
                  className="object-cover w-full h-80 transition-transform duration-300 hover:scale-105"
                />
              </div>
            )}
          </div>
          {/* Mission Section */}
          <div className="relative order-last lg:order-none" data-aos="fade-right">
            {mission.image && (
              <div className="overflow-hidden rounded-xl shadow-lg">
                <img
                  src={mission.image}
                  alt="Mission"
                  className="object-cover w-full h-80 transition-transform duration-300 hover:scale-105"
                />
              </div>
            )}
          </div>
          <div className="flex flex-col gap-6" data-aos="fade-left">
            <h3 className="text-4xl font-bold">{mission.title}</h3>
            <p className="text-lg text-gray-300 leading-relaxed">{mission.description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VisionDesktop;